package org.hs_soft.runmynesto.pages.home.sub_page.user.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum
import org.hs_soft.runmynesto.domain.model.home.user.single_user.GetUser
import org.hs_soft.runmynesto.domain.model.home.user.users_info.UserModel
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.grid_function.FilterActiveGridContent
import org.hs_soft.runmynesto.pages.components.grid_function.GridFunction
import org.hs_soft.runmynesto.pages.components.grid_function.GridItemsList
import org.hs_soft.runmynesto.pages.components.FilterRow

@Composable
fun GridUserBar(
    searchValue: String,
    windowSizeMode: WindowSizeModeEnum,
    showFilterComponent:Boolean,
    selectedFilterOption: GridItemsFilterEnum,
    infoList: List<UserModel>,
    titleDescending: Boolean,
    numberDescending: Boolean,
    showNumberSortIcon: Boolean,
    showTitleSortIcon: Boolean,
    selectedItem: GetUser?,
    onSearchValueChange: (String) -> Unit,
    onTitleSortClick: () -> Unit,
    onNumberSortClick: () -> Unit,
    refreshList: () -> Unit,
    onUserClick: (String) -> Unit,
    onAddRecord: () -> Unit,
    onFilterComponentClick:()->Unit,
    selectFilterType:(GridItemsFilterEnum)->Unit,
    submitFilterItems:()->Unit,
    onCloseFilterClick:()->Unit,
    onSwipeRight:()->Unit,
) {
    Column(
        modifier = Modifier
            .thenIf(
                windowSizeMode==WindowSizeModeEnum.PHONE,
                Modifier.fillMaxWidth()
            )
            .fillMaxHeight()
    )
    {
        FilterRow(
            fillMaxWidth =windowSizeMode==WindowSizeModeEnum.PHONE,
            selectedFilterType = selectedFilterOption,
            onAddRecordClick = {
                onAddRecord()
            },
            onFilterClick = {
                onFilterComponentClick()
            },
        )

        Box(
            modifier = Modifier
                .weight(1f)
                .thenIf(
                    windowSizeMode==WindowSizeModeEnum.PHONE,
                    Modifier.fillMaxWidth()
                )
                .margin(
                    top = Dimen.normalPadding,
                )
        )
        {
            if (showFilterComponent){
                FilterActiveGridContent(
                    selectFilterType = {
                        selectFilterType(it)
                    },
                    selectedFilterType=selectedFilterOption,
                    onCloseFilterClick ={
                        onCloseFilterClick()
                    },
                    submitFilterItems = {
                        submitFilterItems()
                    }

                )
            }

            Column(
                modifier = Modifier
                    .thenIf(
                        windowSizeMode==WindowSizeModeEnum.PHONE,
                        Modifier.fillMaxWidth()
                    )
                    .fillMaxHeight()
            ){

                CustomEditText(
                    width =Dimen.gridWidth,
                    label = "",
                    fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
                    value = searchValue,
                    endIconPath = Res.PathIcon.searchBox,
                    isRequired = false,
                    hint = Strings.current().search,
                    onFocusIn = {},
                    onFocusOut = {},
                    onInputChange = {it, validation ->
                        onSearchValueChange(it)
                    },
                )

                GridFunction(
                    modifier = Modifier ,
                    fillMaxWidth = windowSizeMode==WindowSizeModeEnum.PHONE,
                    title = Strings.current().name,
                    infoTitle = Strings.current().numberDot,
                    footerTitle = Strings.current().users,
                    infoList = infoList,
                    onTitleSortClick = {
                        onTitleSortClick()
                    },
                    onNumberSortClick = {
                        onNumberSortClick()
                    },
                    refreshList = {
                        refreshList()
                    },
                    content = {
                        GridItemsList(
                            id = selectedItem?.id?:"",
                            items = infoList,
                            onItemClick = {
                                onUserClick(it)
                            },
                        )
                    },
                    titleDescending = titleDescending ,
                    numberDescending = numberDescending,
                    showTitleSortIcon = showTitleSortIcon,
                    showNumberSortIcon = showNumberSortIcon,

                )
            }

        }






    }
}